import { Component, Input, OnInit } from '@angular/core';
import { JsFndaUser } from '../../models/layout-model';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { TResult } from 'src/app/shared/models/common-models';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { LayoutService } from 'src/app/shared/auth/layout-service';

@Component({
  selector: 'app-switch-identity',
  templateUrl: './switch-identity.component.html',
  styleUrls: ['./switch-identity.component.scss']
})
export class SwitchIdentityComponent implements OnInit {
  @Input() onSelectData: (data: any) => void;
  selectedUser: JsFndaUser;
  isLoading = false;
  userData: JsFndaUser[];
  originalUser: JsFndaUser;
  constructor(private envServ: EnvironmentconfigService,
    private webApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private auth: AuthService,
    public layoutServ: LayoutService
  ) { }

  ngOnInit(): void {
    this.originalUser = this.auth.getCurrentUserInfo();
    this.setMultiIdentityList();
  }
  selectData(data: any) {
    this.selectedUser = data;
    if (this.onSelectData) {
      this.onSelectData(data);
    }
  }
  getSelectedData() {
    return this.selectedUser;
  }

  setMultiIdentityList() {
    this.isLoading = true;
    const url = `${this.envServ.authConfig.MVMBackEnd}${URLConst.GetMultiIdentity.url}`;
    this.webApiService.doGet(url).subscribe(res => {
      this.isLoading = false;
      const result = res as TResult<JsFndaUser[]>;
      if (res.rc !== 0) {
        this.NzMessageService.error('Get multi-identity info error: ' + res.msg);
        console.error('Get multi-identity info error: ' + res.msg);
      } else {
        this.userData = result.data;
      }
    });
  }
}
